import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';
import { wrapContentWithSeparator } from '../utils/wrapContentWithSeparator.js';

const Caption = styled.span(({ type = 'default', bold, separator, stylish, theme: { olist: { components: { text: { caption }, }, }, }, }) => css `
      display: inline-block;
      ${renderTextVariations(caption, type, bold, stylish)}
      ${separator && wrapContentWithSeparator()}
    `);

export { Caption as default };
